import * as React from "react";

export const IconSaveScanImage = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_35770_43498)">
      <path d="M18.334 5.83398L10.834 5.83398V7.50065L18.334 7.50065V5.83398Z" fill="currentColor" />
      <path d="M18.334 12.5L10.834 12.5V14.1667L18.334 14.1667V12.5Z" fill="currentColor" />
      <path d="M18.334 9.16797H13.334V10.8346H18.334V9.16797Z" fill="currentColor" />
      <path
        d="M10.8337 10.0007L6.66699 5.83398L6.66699 9.16732H1.66699L1.66699 10.834H6.66699L6.66699 14.1673L10.8337 10.0007Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_35770_43498">
        <rect width="20" height="20" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
);
